import styled from 'styled-components';

export const StyledSmartSuggestion = styled.div``;
